// extracted by mini-css-extract-plugin
export default {"spinContainer":"m4Cwzjmw"};